module.exports = __webpack_public_path__ + "img/bg-product-1.868af9a4.png";